import axa from '../../Assets/Departments/Electronics/Axa.jpeg'
import sarthak from '../../Assets/Departments/Electronics/Sarthak Gupta.jpeg'
import nikhil from '../../Assets/Departments/Electronics/NIkhil.jpeg'
import sumeet from '../../Assets/Departments/Electronics/Sumeet Jadhav.jpeg'
import sagar from '../../Assets/Departments/Electronics/Sagar.jpeg'
import parag from '../../Assets/Departments/Electronics/Parag.jpeg'
import Hrishikesh from '../../Assets/Departments/Electronics/Hrishikesh.jpeg'
import Abhishek from '../../Assets/Departments/Electronics/Abhishek.jpeg'




const members = [

     
    {
        name: "Axasusan Mathew",
        imgurl: axa,
        branch: "INSTRU",
        year: "4th Year",
        linkedin: "http://www.linkedin.com/in/axasusan-mathew-08067b1b0",
        instagram: "https://www.instagram.com/axasusanmathew/",
    },
    
    {
        name: "Sagar Warungase ",
        imgurl: sagar,
        branch: "ENTC",
        year: "4th Year",
        linkedin: "http://www.linkedin.com/in/axasusan-mathew-08067b1b0",
        instagram: "https://www.instagram.com/axasusanmathew/",
    },

    {
        name: "Sumeet Jadhav",
        imgurl: sumeet,
        branch: "ENTC",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/sumeet-jadhav-62309421b",
        instagram: "",
    },
    
    {
        name: "Nikhil Motagi",
        imgurl: nikhil,
        branch: "ENTC",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/nikhil-motagi-a17590225/",
        instagram: "https://www.instagram.com/nikhilmotagi/",
    },
    
    {
        name: "Sarthak Gupta",
        imgurl: sarthak,
        branch: "ENTC",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/sarthak-gupta-9b8082220/",
        instagram: "",
    },
    {
        name: "Hrishikesh Kshetramade",
        imgurl: Hrishikesh,
        branch: "ENTC",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/hrishikesh-kshetramade-764565233/",
        instagram: "",
    },
    {
        name: "Parag Kale",
        imgurl: parag,
        branch: "INSTRU",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/parag-kale-79294021a",
        instagram: "https://www.instagram.com/paragkale__/",
    },
    {
        name: "Abhishek",
        imgurl: Abhishek,
        branch: "ENTC",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/abhishek-raskar-954052216/",
        instagram: "https://www.instagram.com/raskarabhi45/",
    },
     



]
export default members